<template >
     <vs-popup class="popup"  title="Update" :active.sync="bulkupdateModal">
 <vs-select
 @input="multifetch(update_Field.input_type)"
      label="Update Field"
      v-model="update_Field"
      placeholder="Select" 
      style="width:100%; margin-bottom: 10px;"
      >
        <vs-select-item v-if="item.field_label!='Email' && item.field_label!='Created at' && item.field_label!='Phone' && item.field_label!='User Type'" :key="index" :value="item" :text="item.field_label" v-for="(item,index) in displayListofdata" />
        
      </vs-select>   
    <!--   {{custom_fields}} -->
      <!-- {{update_Field}} -->
      <vs-input v-if="update_Field.field_label=='multi_user'" style="width:100%"  label="Write here to Update"  v-model="update_field_value"/>
        <vs-input v-if="update_Field.input_type=='text'" style="width:100%"  label="Write here to Update"  v-model="update_field_value"/>
   <vs-input v-else-if="update_Field.input_type=='number'" type="number" style="width:100%"  label="Write here to Update"  v-model="update_field_value"/>
         

    <vs-textarea v-else-if="update_Field.input_type=='textarea'"
    v-model="update_field_value"
    label="Write here to Update"
        class="w-full"
      />
      
       <vs-checkbox
       v-else-if="update_Field.input_type=='checkbox'"
          v-for="value in multivalues"
          :key="value.id"
          v-model="checkboxValue"
          :vs-value="value.optionsvaluename"
        >
          {{ value.optionsvaluename }}
        </vs-checkbox>
         <v-select
          v-else-if="update_Field.input_type=='multiselect'"
          multiple
          label="optionsvaluename"
          :closeOnSelect="false"
          v-model="update_field_value"
          :reduce="(option) => option.optionsvaluename"
          :options="multivalues"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
        <li
         v-else-if="update_Field.input_type=='radio'"
            v-for="multivalue in multivalues"
            :key="multivalue.id"
          >
         <vs-radio
             v-model="update_field_value"

              :vs-value="multivalue.optionsvaluename"
            >
              {{ multivalue.optionsvaluename }}
            </vs-radio>
        </li>
        <li v-else-if="update_Field.input_type == 'boolean'">
         <ul class="ml-2">
          <li>
            <vs-radio
              
              id="radiodynamic"
              v-model="update_field_value"
              
              vs-value="1"
            >
              True
            </vs-radio>

            <vs-radio
              v-model="update_field_value"
              vs-value="0"
            >
              False
            </vs-radio>
          </li>
        </ul>
      </li>
      <li
        v-else-if="update_Field.input_type === 'datetime'"
        class="mb-4"
        style="width: 100%"
      >
        <ul class="">
          <label class="vs-input--label">Choose Date</label>
          <flat-pickr
            style="width: 100%"
            v-model="update_field_value"
          />
         
        </ul>
      </li>
      <li v-if="update_Field.input_type === 'select'" class="mb-4">
 <vs-select v-if="update_Field.field_name=='platform_customer_countries_id'"
      label="Update Field Value"
      v-model="update_field_value"
      placeholder="Select" 
      style="width:100%"
      >
      
    <vs-select-item :key="index" :value="item.id" :text="item.country_name" v-for="(item,index) in countryList" />
      </vs-select> 
      <vs-select v-else-if="update_Field.field_name=='leads_current_status_id'"
      label="Update Field Value"
      v-model="update_field_value"
      placeholder="Select" 
      style="width:100%"
      >
          <vs-select-item :key="index" :value="item.leads_status_id" :text="item.status_name" v-for="(item,index) in active_status_list" />
      </vs-select> 
        <select v-else
          v-model="update_field_value"
          id="selectdynamic"
          style="width: 100%"
        >
          <option
            v-for="multivalue in multivalues"
            :key="multivalue.id"
            :value="multivalue.optionsvaluename"
          >
            {{ multivalue.optionsvaluename }}
          </option>
        </select>
      </li>
    <vs-button class="updateBtn mt-4" color="primary" @click="bulkupdate()"  type="filled">Submit</vs-button>
  
     
    </vs-popup>
</template>
<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
export default {
  props:{
    custom_fields_required:{
      type:Array,
      required:true,
      default:() => {}
    },
    displayListofdata:{
      type:Array,
      required:true,
      default:() => {}
    },
    countryList: {
      type: Array,
      required: true,
      default: () => []
    },
     active_status_list: {
      type: Array,
      default: () => []
    },

  },
  components:{
    vSelect,
    flatPickr
  },
  data () {
    return {
      custom_fields: this.custom_fields_required,
      bulkupdateModal: true,
      multivalues:'',
      update_Field:'',
      update_field_value:'',
      checkboxValue:[]
      
    }
  },
  methods:{
    multifetch(type){
      this.custom_fields=this.custom_fields.filter(element=>{
        console.log(element)
        if(element.input_type==type){
       return element.multivalue
      }
       })
       this.multivalues = this.custom_fields[0].multivalue
      console.log(this.custom_fields)
    },
    bulkupdate () {
      if(this.checkboxValue.length > 0){
        this.update_field_value = this.checkboxValue
      }
      const update_list = []
      update_list.push(this.update_Field.field_name, this.update_field_value)
      this.$emit('bulkupdatelist', update_list)
      this.update_Field=''
      this.update_field_value=''
      //update_list = []
    }
  }
}
</script>
<style>

    
</style>

